import 'antd/dist/reset.css';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './config/axiosConfig';
import AppRoutes from './router/router';
import './styles/message.css';

const rootElement = document.getElementById('root');

// Only initialize PostHog in production
const isProduction = process.env.NODE_ENV === 'production';
const postHogKey = process.env.REACT_APP_POSTHOG_KEY;
const postHogHost = process.env.REACT_APP_POSTHOG_HOST;

// Check if PostHog should be enabled (production + valid config)
const shouldEnablePostHog = isProduction && postHogKey && postHogHost;
// const shouldEnablePostHog = true;

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement as HTMLElement);

  const AppContent = (
    <Router>
      <AppRoutes />
    </Router>
  );

  root.render(
    <React.StrictMode>
      {shouldEnablePostHog ? (
        <PostHogProvider
          apiKey={postHogKey as string}
          options={{
            api_host: postHogHost,
            capture_exceptions: true, // This enables capturing exceptions using Error Tracking
            debug: false, // Always false in production
          }}
        >
          {AppContent}
        </PostHogProvider>
      ) : (
        AppContent
      )}
    </React.StrictMode>
  );
} else {
  throw new Error('Root Element not found');
}
